<div class="app-faqs">
    <app-header class="header-mobile"></app-header>
    <header class="header">
        <div class="container-logo">
            <div class="logo"><img (click)="goToUrl()" src="./assets/temporals/Logo_Akana_Azul.png" alt=""></div>
            <div *ngIf="showName" class="faqs">
                <p>{{'FAQS.NAME' | translate}}&nbsp;&nbsp;&nbsp;</p><img src="./assets/logos/faq.svg" alt="">
            </div>
        </div>
    </header>
    <div class="content-faqs">
        <p class="tittle-faqs">Preguntas frecuentes</p>
        <div class="faqs">
            <mat-accordion>
                <mat-expansion-panel *ngFor="let item of dataAccess | keyvalue; let i = index">
                    <mat-expansion-panel-header (click)="datanicals(item)">
                        <mat-panel-title>
                            {{ 'FAQS.QUESTIONS.' + (i + 1) | translate}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [innerHTML]="'FAQS.ANSWERS.' + (i + 1) | translate"></div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>
<app-footer class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>